import { motion } from "motion/react";

interface GalleryCardProps {
  src: string;
  alt: string;
  index: number;
}

const getEntryAnimation = (index: number) => {
  const animations = [
    { animation: "fade-in-up", delay: 0.1 },
    { animation: "slide-in-left", delay: 0.2 },
    { animation: "slide-in-right", delay: 0.3 },
    { animation: "zoom-in", delay: 0.4 },
    { animation: "fade-in-up", delay: 0.5 },
    { animation: "zoom-in", delay: 0.6 }
  ];
  return animations[index % animations.length];
};

export const GalleryCard = ({ src, alt, index }: GalleryCardProps) => {
  const { delay } = getEntryAnimation(index);
  
  return (
    <motion.div
      initial={{ opacity: 0, y: 60, scale: 0.8 }}
      animate={{ 
        opacity: 1, 
        y: 0, 
        scale: 1,
        transition: {
          type: "spring",
          damping: 25,
          stiffness: 100,
          delay: delay,
          duration: 0.8
        }
      }}
      className="group relative overflow-hidden rounded-2xl bg-gallery-card border border-border shadow-lg shadow-primary/5 transition-all duration-500"
    >
      <div className="aspect-square relative overflow-hidden">
        <motion.img
          src={src}
          alt={alt}
          className="w-full h-full object-cover"
          loading="lazy"
          initial={{ scale: 1.2 }}
          animate={{ 
            scale: 1,
            transition: {
              type: "spring",
              damping: 20,
              stiffness: 100,
              delay: delay + 0.2,
              duration: 1
            }
          }}
        />
        
        {/* Subtle glow effect */}
        <div className="absolute -inset-1 bg-gradient-primary opacity-0 group-hover:opacity-10 blur-xl transition-all duration-700 -z-10" />
      </div>
    </motion.div>
  );
};
